import { Box, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, SelectVariants, Stack, TextField } from "@mui/material"
import { useCallback } from "react"
import { FieldTitle, InputHelperText, InputProps, regex, useInput, useRecordContext } from "react-admin"

const durationRE = /(-?(?:\d+\.?\d*|\d*\.?\d+)(?:e[-+]?\d+)?)\s*([\p{L}]*)/ui

const units = [
    { id: "s", name: "sec" },
    { id: "sec", name: "sec" },
    { id: "m", name: "min" },
    { id: "min", name: "min" },
    { id: "h", name: "hours" },
    { id: "hr", name: "hours" },
    { id: "d", name: "day" },
    { id: "w", name: "week" },
    { id: "months", name: "months" },
    { id: "y", name: "years" },
]
const validateValue = regex(/\d+[a-z]+/iu, "Invalid Duration")

interface Props extends InputProps {
    variant?: SelectVariants,
}

export const DurationInput = <P extends Props>(props: P) => {


    const { variant = "outlined", label, source, resource } = props;
    const {
        field,//: { name, value, onChange, ...rest },
        isRequired,
        fieldState: { error },
    } = useInput({ ...props, validate: validateValue })

    const strVal: string = field.value;
    console.log({ strVal })
    const match = strVal.match(durationRE)
    const [, num, unit] = match || [, "", ""]


    const handleNumChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        const val = event.target.value;
        field.onChange(`${val}${unit}`)
    }, [field, unit])

    const handleUnitChange = useCallback((event: SelectChangeEvent) => {
        const val = event.target.value;
        field.onChange(`${num}${val}`)
    }, [field, num])

    const textLabel = label !== '' && label !== false && (
        <FieldTitle
            label={label}
            isRequired={isRequired}
            source={source}
            resource={resource}
        />
    )

    const helperText =
        <InputHelperText
            error={error?.message}
            helperText={false}
        />


    return (
        <Stack direction={"row"} spacing={1}>
            <TextField variant={variant} label={textLabel} value={num} onChange={handleNumChange} helperText={helperText} />
            <FormControl variant={variant} sx={{ width: "150px" }}>
                <InputLabel>Units</InputLabel>
                <Select value={unit} onChange={handleUnitChange} >
                    {units.map(({ id, name }) => <MenuItem key={id} value={id}>{name}</MenuItem>)}
                </Select>
            </FormControl>
        </Stack >

    )
}